import "../App.css";

function InvalidURL() {
  return (
    <div className="App">
      <h3 className="App-header">Error 404</h3>
    </div>
  );
}

export default InvalidURL;
